<template lang="pug">
.form-residential-other__form
  .form-residential-other__form-item
      span.form-residential-other__form-title
          | Расширенное
          br
          | описание у логотипа

      .form-residential-other__form-elements--small.radio
          SvCheckbox.form-residential-other__form-radio(
              v-model="is_wide_logo_description"
          )

  .form-residential-other__form-item
      span.form-residential-other__form-title
          | Формулировка
          br
          | "Апартаменты"

      .form-residential-other__form-elements--small.radio
          SvCheckbox.form-residential-other__form-radio(
              v-model="is_apartments"
          )

  .form-residential-other__form-item
      span.form-residential-other__form-title
          | Формулировка
          br
          | "отдел продаж"

      .form-residential-other__form-elements--small.radio
          SvCheckbox.form-residential-other__form-radio(
              v-model="sales_department_formulation"
          )

  .form-residential-other__form-item
      span.form-residential-other__form-title
          | Скрыть лого застройщика

      .form-residential-other__form-elements--small.radio
          SvCheckbox.form-residential-other__form-radio(
              v-model="no_developer_logo"
          )

  .form-residential-other__form-item
      span.form-residential-other__form-title--centered
          | Ссылка на сайт застройщика

      .form-residential-other__form-elements--small.radio
          SvInput.form-residential-other__form-radio(
              v-model="developer_url"
              placeholder="Например: svoe"
              color="graylight"
              :withIcon="false"
              :style="{ width: '311px' }"
          )

  .form-residential-other__form-item
      span.form-residential-other__form-title--centered
          | Актуальный прайс

      .form-residential-other__form-elements--small
          SvUploadDoc(
              v-model="price_list"
          )
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import SvCheckbox from '@/components/uikit/SvCheckbox.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvUploadDoc from '@/components/uikit/SvUploadDoc.vue';

export default {
  name: 'FormResidentialOther',

  computed: {
    ...mapGetters({
      current: 'residential/getCurrent',
    }),

    is_wide_logo_description: {
      get() {
        return this.current.is_wide_logo_description;
      },
      set(is_wide_logo_description) {
        this.setValue({ is_wide_logo_description });
      },
    },

    is_apartments: {
      get() {
        return this.current.is_apartments;
      },
      set(is_apartments) {
        this.setValue({ is_apartments });
      },
    },

    sales_department_formulation: {
      get() {
        return this.current.sales_department_formulation;
      },
      set(sales_department_formulation) {
        this.setValue({ sales_department_formulation });
      },
    },

    no_developer_logo: {
      get() {
        return this.current.no_developer_logo;
      },

      set(no_developer_logo) {
        this.setValue({ no_developer_logo });
      },
    },

    developer_url: {
      get() {
        return this.current.developer_url;
      },

      set(developer_url) {
        this.setValue({ developer_url });
      },
    },

    price_list: {
      get() {
        return this.current.price_list;
      },

      set(price_list) {
        this.setValue({ price_list });
      },
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'residential/setValue',
    }),
  },

  components: {
    SvInput,
    SvUploadDoc,
    SvCheckbox,
  },
};
</script>

<style lang="scss" scoped>
.form-residential-other__form {
  min-height: calc(100vh - 238px);
  padding-top: 50px;
  padding-left: 30px;
}

.form-residential-other__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.form-residential-other__form-title {
  text-align: right;
  margin-right: 50px;
  justify-content: flex-end;

  &--centered {
    text-align: right;
    margin-right: 50px;
    align-self: center;
  }
}

.form-residential-other__form-item {
  display: grid;
  grid-template-columns: 290px 1fr;
  align-content: center;
  margin-top: 25px;
}
</style>
